import AboutCompany from "../Pages/AboutCompany/AboutCompany";
import Summary from "../Pages/Summary/Summary";
import StartTest from "../Pages/Start Test/StartTest";
import EnterDetails from "../Pages/Enter Details/EnterDetails";
import CheckSystem from "../Pages/CheckSystem/CheckSystem";
import NotAccessible from "../Not Accessible/NotAccessible";
import WhoWeAre from "../Pages/Who We Are/WhoWeAre";
import Overview from "../Pages/Overview/Overview";
import Review from "../Pages/Review/Review";
import Home from "../Pages/Home/Home";
import CandidateResultsSection from "../Pages/CandidateResults/CandidateResultsSection";
import FeedbackPage from "../Pages/Feedback/FeedbackPage";
import AssessmentPaused from "../Pages/AssessmentPaused/AssessmentPaused";

const publicRoutes = [
  { path: "/", component: WhoWeAre },
  { path: "/:userId/:testDetails", component: AboutCompany },
  { path: "/summary/:userId/:testDetails", component: Summary },
  {
    path: "/candidateResults/:candidateAssessmentId",
    component: CandidateResultsSection,
  },
  { path: "/notaccessible", component: NotAccessible },
  { path: "/assessment-paused", component: AssessmentPaused },
  { path: "/feedback", component: FeedbackPage },
];

const authProtectedRoutes = [
  { path: "/enter-details", component: EnterDetails },
  { path: "/check-system", component: CheckSystem },
  { path: "/start-test", component: StartTest },
];

const authProtectedRoutesFull = [
  { path: "/overview", component: Overview, fullScreen: true },
  { path: "/review", component: Review, fullScreen: true },
];

export { publicRoutes, authProtectedRoutes, authProtectedRoutesFull };
